<template>
  <transition :name="disableTransitions ? '' : 'zm-zoom-in-center'">
    <span
      class="zm-tag"
      :class="[
        type ? 'zm-tag--' + type : '',
        tagSize && `zm-tag--${tagSize}`,
        {'is-hit': hit, 'zm-tag--closable': closable}
      ]"
      :style="{backgroundColor: color}">
      <slot></slot>
      <button
        class="zm-tag__close"
        type="button"
        v-if="closable"
        tabindex="0"
        role="button"
        :aria-label="deleteText"
        @click.stop="handleClose">
        <i class="zm-icon-close"></i>
      </button>
    </span>
  </transition>
</template>
<script>
  import '../../../i18n/tag';
  import Locale from '../../mixins/locale';
  import {t} from '../../locale';

  export default {
    name: 'ZmTag',
    mixins: [Locale],
    props: {
      text: String,
      closable: Boolean,
      type: {
        type: String,
        default: 'info'
      },
      hit: Boolean,
      disableTransitions: Boolean,
      color: String,
      size: {
        type: String,
        default: 'middle'
      },
      deleteText: {
        type: String,
        default() {
          return t('tag.delete');
        }
      }
    },
    methods: {
      handleClose(event) {
        this.$emit('close', event);
      }
    },
    computed: {
      tagSize() {
        return this.size || (this.$ELEMENT || {}).size;
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(tag) {
    background-color: $--tag-fill;
    display: inline-block;
    vertical-align: middle;
    color: $--tag-color;
    border-radius: $--tag-border-radius;
    box-sizing: border-box;
    border: none;
    white-space: nowrap;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;

    .zm-tag__close {
      border-radius: 50%;
      text-align: center;
      position: absolute;
      cursor: pointer;
      font-size: 12px;
      height: 14px;
      width: 14px;
      display: inline-block;
      line-height: 14px;
      vertical-align: middle;
      right: 5px;
      color: $--tag-color;
      border-width: 0;
      background-color: transparent;
      border-color: transparent;
      padding: 0;

      &:hover,
      &:focus {
        background-color: $--tag-color;
        color: $--color-white;
      }

      &:focus {
        outline: none;
      }

      .zm-icon-close {
        font-size: 14px;
      }
    }

    @include m(info) {
      background-color: $--tag-info-fill;
      border-color: $--tag-info-border;
      color: $--tag-info-color;

      @include when(hit) {
        border-color: $--tag-info-color;
      }

      .zm-tag__close {
        color: $--color-info;
      }

      .zm-tag__close:hover,
      .zm-tag__close:focus {
        background-color: $--tag-info-color;
        color: $--color-white;
      }
    }

    @include m(success) {
      background-color: $--tag-success-fill;
      border-color: $--tag-success-border;
      color: $--tag-success-color;

      @include when(hit) {
        border-color: $--tag-success-color;
      }

      .zm-tag__close {
        color: $--tag-success-color;
      }

      .zm-tag__close:hover,
      .zm-tag__close:focus {
        background-color: $--tag-success-color;
        color: $--color-white;
      }
    }

    @include m(warning) {
      background-color: $--tag-warning-fill;
      border-color: $--tag-warning-border;
      color: $--tag-warning-color;

      @include when(hit) {
        border-color: $--tag-warning-color;
      }

      .zm-tag__close {
        color: $--tag-warning-color;
      }

      .zm-tag__close:hover,
      .zm-tag__close:focus {
        background-color: $--tag-warning-color;
        color: $--color-white;
      }
    }

    @include m(danger) {
      background-color: $--tag-danger-fill;
      border-color: $--tag-danger-border;
      color: $--tag-danger-color;

      @include when(hit) {
        border-color: $--tag-danger-color;
      }

      .zm-tag__close {
        color: $--tag-danger-color;
      }

      .zm-tag__close:hover,
      .zm-tag__close:focus {
        background-color: $--tag-danger-color;
        color: $--color-white;
      }
    }
    @include m(large) {
      padding: $--tag-padding;
      font-size: $--tag-font-size;
      height: $--size-height-large;
      line-height: #{ $--size-height-large - 2px };
      &.zm-tag--closable{
        padding-right: 30px;
      }
      .zm-tag__close {
        top: 11px;
        right: 7px;
      }
    }
    @include m(middle) {
      height: $--size-height-default;
      padding: 0 12px;
      line-height: $--size-height-default;
      font-size: 14px;
      &.zm-tag--closable{
        padding-right: 28px;
      }
      .zm-tag__close {
        top: 7px;
      }
    }
    @include m(small) {
      height: $--size-height-small;
      padding: 0 8px;
      line-height: $--size-height-small;
      font-size: 14px;
      &.zm-tag--closable{
        padding-right: 28px;
      }
      .zm-tag__close {
        top: 4px;
      }
    }


    @include m(mini) {
      height: 18px;
      padding: 0 5px;
      line-height: 18px;
      &.zm-tag--closable{
        padding-right: 25px;
      }
      font-size: 12px;
      .zm-tag__close {
        top: 2px;
        transform: scale(.85);
      }
    }
  }
</style>
